// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "Comissões das OTAs",
    sub: "Quanto cada canal retém das suas reservas. Com isso, a ficha de cada reserva mostra uma estimativa do que você recebe.",
  },
  loading: "Carregando as comissões…",
  loadError: {
    title: "Não foi possível carregar as comissões",
    text: "Verifique a conexão e tente novamente.",
    retry: "Tentar novamente",
  },
  display: {
    title: "Preço das reservas de OTA na ficha",
    totalLabel: "Só o total enviado pela OTA",
    totalDesc: "Como até agora: o valor da reserva.",
    netLabel: "Também o que chega até você",
    netDesc: "Além do total, a ficha mostra a comissão, o imposto (IVA) sobre a comissão e o valor líquido que você vai receber.",
  },
  rates: {
    title: "Comissão e taxas de cada OTA",
    hint: "Coloque o % que aparece na extranet de cada OTA (no Booking: \"Comissão e taxas\" ÷ \"Preço total\"). Se o canal informar a comissão real de uma reserva, é ela que vale.",
    usual: "habitual: {pct}%",
    airbnbNote: "O Airbnb paga o valor já líquido: a comissão dele já vem descontada. Deixe em branco (0%), a menos que a sua conexão receba o total.",
    managedNote: "Estes percentuais também são usados no repasse ao seu proprietário.",
  },
  vat: {
    title: "Imposto (IVA) sobre a comissão da OTA",
    hint: "O Booking cobra IVA sobre a comissão dos alojamentos na Espanha (21%) e o desconta da transferência. Coloque 0 se isso não for cobrado de você.",
  },
  errPercent: "Precisa ser um percentual entre 0 e 100.",
  example: {
    title: "Exemplo",
    sub: "Uma reserva do {channel} de {total}",
    total: "Preço total",
    commission: "Comissão e taxas do {channel} ({pct}%)",
    vat: "Imposto sobre a comissão ({pct}%)",
    net: "Você recebe",
    foot: "É uma estimativa com estes percentuais: a OTA pode transferir um valor um pouco diferente (arredondamentos, promoções, taxas de pagamento). Se o canal informar a comissão real, a ficha usa essa.",
  },
  footer: {
    save: "Salvar",
    saving: "Salvando…",
    saved: "Comissões salvas",
    unsaved: "Alterações não salvas",
    fixErrors: "Revise os campos marcados",
    errSave: "Não foi possível salvar as alterações. Tente novamente.",
    errInvalid: "A comissão de cada OTA precisa ser um percentual entre 0 e 100.",
  },
};
